import { ICustomProperties, IEventTelemetry } from "@microsoft/applicationinsights-web";
import { CloseTaskEventSource } from "./CloseTaskEventSource";

export class CloseTaskEvent implements IEventTelemetry {
    name: string = "CloseTaskEvent";
    trigger: string;

    constructor(source: CloseTaskEventSource) {
        this.trigger = source.toString();
    }

    public getCustomProperties = (): ICustomProperties => {
        return {
            trigger: this.trigger,
        };
    };
}
